+<template>
  <div>
    <div v-if="exportable" class="d-flex justify-content-end my-1">
      <loader-btn
        :loading="exporting"
        variant="warning"
        label="تصدير"
        icon="ArrowDownCircleIcon"
        @click="exportToExcel(ep)"
        size="sm"
      />
    </div>
    <b-table
      v-bind="$attrs"
      v-on="$listeners"
      ref="dataTable"
      :fields="fields"
      :items="items || myProvider"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :busy.sync="loading"
      :api-url="ep"
      empty-filtered-text="لا يوجد نتائج تطابق البحث"
      empty-text="لا يوجد سجلات لعرضها"
      no-local-sorting
      show-empty
      responsive
    >
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle mx-2"></b-spinner>
          <strong>جاري التحميل...</strong>
        </div>
      </template>
      <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"></slot>
      </template>
    </b-table>
    <div class="my-1" v-if="pagination">
      <b-row>
        <b-col
          v-if="!hidePageSize"
          lg="5"
          sm="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          عدد المدخلات في الصفحة
          <b-form-select
            style="width: 50%"
            v-model="perPage"
            :options="pageOptions"
            class="mx-1"
          />

          <!-- <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span> -->
        </b-col>
        <!-- Pagination -->
        <b-col
          lg="7"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import loaderBtn from "../loader-btn.vue";
import {
  BTable,
  BPagination,
  BFormSelect,
  BRow,
  BCol,
  BSpinner,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";

import get from "lodash.get";

export default {
  components: {
    BTable,
    BPagination,
    BFormSelect,
    BRow,
    BCol,
    BSpinner,
    BFormSelect,
    loaderBtn,
  },
  props: {
    id: { type: String, default: () => Math.random().toString() },
    ep: { type: String, default: () => null },
    items: { type: Array, default: () => null },
    fields: { type: Array, default: () => [] },
    pagination: { type: Boolean, default: () => true },
    dataPath: {
      type: String,
      default: () => "data",
    },
    hidePageSize: { type: Boolean, default: () => false },
    exportable: { type: Boolean, default: () => false },
    initialParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      pageOptions: [10, 15, 20, 25],
      loading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      queryParams: {},
    };
  },
  computed: {
    ...mapGetters("Exporter", ["exporting"]),
    moduleName() {
      return `Data Table ${this.id}`;
    },
  },

  methods: {
    ...mapActions("Exporter", ["exportToExcel"]),
    setQueryParams(params) {
      this.queryParams = { ...params };
    },
    refreshTable() {
      this.$refs.dataTable.refresh();
    },
    myProvider(ctx, callback) {
      this.loading = true;
      if (this.items) {
        callback(this.items);
      } else {
        this.$axios
          .get(this.ep, {
            params: {
              page: ctx.currentPage,
              size: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc,
              ...this.queryParams,
            },
          })
          .then((res) => {
            if (this.pagination && res.data.pagination) {
              this.totalRows = res.data.pagination
                ? res.data.pagination.total_row
                : res.data.data.length;
            }
            const resolved = get(res.data, this.dataPath);
            callback(resolved);
          })
          .catch((err) => {
            callback([]);
          });
      }

      this.loading = false;

      return null;
    },
  },

  created() {
    this.queryParams = { ...this.initialParams };
  },
};
</script>
